/**
 * Общий модуль для всех лисалок на сайте.
 * Библиотека загружается по мере необходимости.
 */
itsoftApp.createModule("slidersLibrary", function() {
    // Локальные переменные
    var module = this;
    var queue = [];
    var libraryLoaded = false;
    var loadingStarted = false;


    /**
     * Вызов всех функций, которые были добавлены
     * в массив queue в процессе загрузки библиотеки
     * (до этого момента их вызов привёл бы к ошибке).
     */
    var initQueue = function() {
        if (!libraryLoaded) {
            return false;
        }

        var qLen = queue.length;
        if (!qLen) {
            return;
        }

        DEBUG && console.log("[module slidersLibrary] initQueue function fired, queue.length: " + qLen);

        while (queue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            queue.shift()();
        }
    };


    /**
     * Загрузить библиотеку и выполнить
     * отложенные функции из массива queue.
     */
    var loadAndInit = function() {
        var f = function() {
            libraryLoaded = true;
            initQueue();
        };

        // Случай, если библиотека вдруг уже загружена
        // (например, если она принудительна вставлена в html через <script>)
        itsoftApp.loadStyle("assets/scripts/swiper/swiper.min.css");
        itsoftApp.loadScript("assets/scripts/swiper/swiper.min.js", function() {
            DEBUG && console.log("[module slidersLibrary] library loaded, ready to init queue");
            f();
        });
    };


    /**
     * Добавление переданной функции в очередь на выполнение,
     * либо немедленное исполнение функции, если библиотека уже загружена.
     *
     * @param {function} func
     */
    var addEvent = function(func) {
        if (typeof func !== "function") {
            return;
        }

        // Если библиотека ещё не загружена, то добавляем в очередь
        if (!libraryLoaded) {

            // Если библиотека ещё не начала грузиться, то загружаем её
            // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
            if (!loadingStarted) {
                loadingStarted = true;
                DEBUG && console.log("%c--[module slidersLibrary] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
                itsoftApp.modules.pageLoad.addEvent(loadAndInit);
            }

            queue.push(func);
            DEBUG && console.log("[module slidersLibrary] function added, count of functions to init now: " + queue.length);

        // Если библиотека уже загружена, то просто вызываем переданную функцию
        } else {
            func();
        }
    };


    // Доступ к функциям
    // текущего модуля
    module.addEvent = addEvent;

    var setSlider = function (el, settings, cb, name, currentSlide) {
        var createSlider = function () {
            var sliderContainer = el.querySelector(".swiper-container");
            var navigation = el.querySelector(".swiper-navigation");
            var pagination = el.querySelector(".swiper-pagination");
            var scrollbar = el.querySelector(".swiper-scrollbar");
            // var slideCount = el.getAttribute("data-slide-count");
            var dataDevice = el.getAttribute("data-destroy-device");
            var sliderName = sliderContainer.getAttribute("data-name");
            var destroyDirection = el.getAttribute("data-destroy-direction");
            var withoutNavigation = el.hasAttribute("data-without-navigation");
            var withoutPagination = el.hasAttribute("data-without-pagination");
            // var freeMode = el.getAttribute("data-free-mode");
            // var dataGap = el.getAttribute("data-gap");
            var isInitialized = false;
            var initializedSlider;
            var sliderSettings;

            if (name) {
                var sliderName = name;
            }

            if (settings) {
                sliderSettings = settings;
            } else {
                sliderSettings = {
                    slidesPerView: 1,
                    watchOverflow: true,
                    loop: true,
                    a11y: {
                        firstSlideMessage: "",
                        lastSlideMessage: ""
                    },
                    simulateTouch: true,
                    keyboard: {
                        enabled: true,
                        onlyInViewport: true
                    },
                    thumbs: {
                        swiper: {
                            el: '.benefits__thumbs',
                            slideClass: 'icon-benefits',
                            slidesPerView: 'auto',
                            followFinger: false,
                        }
                    },
                    pagination: {
                        clickable: true,
                    },
                }

                if (sliderName) {
                    sliderSettings.on = {
                        init: function () {
                            var swiper = this;
                            module.sliders[sliderName] = swiper;
                        }
                    }
                }

                if (scrollbar) {
                    sliderSettings.scrollbar = {
                        el: scrollbar,
                        draggable: true
                    }
                }
            }

            if (!withoutNavigation && navigation) {
                var prevBtn = navigation.querySelector(".js-prev-btn");
                var nextBtn = navigation.querySelector(".js-next-btn");

                sliderSettings.navigation = {};
                sliderSettings.navigation.prevEl = prevBtn;
                sliderSettings.navigation.nextEl = nextBtn;
            }

            if (!withoutPagination && pagination) {
                sliderSettings.pagination = {};
                sliderSettings.pagination.el = pagination;

                if (pagination.classList.contains("js-pagination-dots")) {
                    sliderSettings.pagination.type = "bullets";
                    sliderSettings.pagination.clickable = "true";
                } else {
                    sliderSettings.pagination.type = "fraction";
                    sliderSettings.pagination.renderFraction = function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                              '/' +
                              '<span class="' + totalClass + '"></span>';
                    }
                }
            }

            var destroySlider = function () {
                initializedSlider.destroy(false, true);
                initializedSlider = undefined;
                isInitialized = false;
            }

            var initSlider = function () {
                initializedSlider = new Swiper(sliderContainer, sliderSettings);

                if (initializedSlider) {
                    if (sliderName) {
                        module.slider[sliderName] = initializedSlider;
                    }

                    if (currentSlide) {
                        initializedSlider.slideTo(+currentSlide);
                    }

                    isInitialized = true;
                }
            }

            var onWindowResize = function () {
                if (destroyDirection === "from" && dataDevice && itsoftApp.utils.getViewportSize() >= +dataDevice) {
                    if (isInitialized === true) {
                        destroySlider();
                    }
                } else if (destroyDirection === "to" && dataDevice && itsoftApp.utils.getViewportSize() <= +dataDevice) {
                    if (isInitialized === true) {
                        destroySlider();
                    }
                } else {
                    if (isInitialized === false) {
                        initSlider();
                    }
                }
            }

            if (dataDevice) {
                onWindowResize();
                itsoftApp.modules.windowResize.addEvent(onWindowResize);
            } else {
                initSlider();
            }
        }



        if (el.hasAttribute("data-delay")) {
            setTimeout(function () {
                addEvent(createSlider);
            }, +(el.getAttribute("data-delay")));
        } else {
            addEvent(createSlider);
        }
    }

    module.slider = {};
    module.sliders = {};
    module.callback = setSlider;
});